import {
  faMicrophone,
  faMicrophoneSlash,
  faShieldAlt,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ProgressBar from "@ramonak/react-progress-bar";
import classNames from "classnames";
import React, { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router";
import style from "../assets/css/page/StoryMatch.module.css";
import LogoHeader from "../components/Header/LogoHeader";
import { socket } from "../config/socket";
import { useQuery } from "@apollo/client";

import { GET_MATCH_STORY } from "../graphql/queries";
import Loading from "../components/Loading";

import goal from "../assets/img/iconGoal.png";
import red from "../assets/img/red.png";
import yellow from "../assets/img/yellow.png";
import foul from "../assets/img/foul.png";
import corner from "../assets/img/corner.png";
import penalty from "../assets/img/penalty.png";
import change from "../assets/img/change.png";

function StoryMatch() {
  const location = useLocation();
  const idMatch = location.state.idMatch;
  const storiesRef = useRef(null);
  const { data, loading, error } = useQuery(GET_MATCH_STORY, {
    variables: {
      IdMatch: idMatch,
      State: "LIVE",
    },
  });
  const [match, setMatch] = useState([]);
  const [storyMatch, setStoryMatch] = useState([]);
  const [showStories, setShowStories] = useState(true);

  useEffect(() => {
    if (!loading && data) {
      setMatch(data?.match);
      setStoryMatch(data?.match?.stories);
    }
  }, [loading, data]);

  useEffect(() => {
    socket.on("updateMatch", (res) => {
      let updateMatch = {
        ...match,
        goalLocal: res.match.goalLocal,
        goalVisit: res.match.goalVisit,
      };

      setMatch(updateMatch);
    });
  }, [match]);

  // useEffect(() => {
  //   socket.on("changeStatus", (res) => {
  //     let updateMatch = {
  //       ...match,
  //       StatusMatch: res.statusChange.StatusMatch,
  //     };

  //     setMatch(updateMatch);
  //   });
  // }, [match]);

  useEffect(() => {
    socket.on("newStory", (res) => {
      setStoryMatch((storyMatch) => [...storyMatch, res.story]);
    });
  }, []);

  const scrollToBottom = () => {
    storiesRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    scrollToBottom();
  }, [storyMatch]);

  if (loading) return <Loading />;

  if (error)
    return (
      <div>
        <p>Lo sentimos a ocurrido un error al traer los datos</p>
      </div>
    );

  return (
    <div className={style.container}>
      <div className={style.stadistic}>
        <div className={style.header}>
          <LogoHeader />
          <button
            className={
              showStories
                ? classNames(style.btnStories, style.hiddenStories)
                : style.btnStories
            }
            onClick={() => setShowStories(!showStories)}
          >
            {showStories ? (
              <FontAwesomeIcon icon={faMicrophoneSlash} />
            ) : (
              <FontAwesomeIcon icon={faMicrophone} />
            )}
          </button>
        </div>
        <div className={style.infoTeams}>
          <div className={style.contPlayers}>
            <div className={style.players}>
              <p
                className={style.nameTeam}
                style={{ color: match?.local?.colorShirt }}
              >
                {match?.local?.name}
              </p>
              {match?.local?.players?.map((player) => (
                <div key={player.id} className={style.dataPlayer}>
                  <p className={style.number}>
                    {player.numShirt < 10
                      ? `0${player.numShirt}`
                      : player.numShirt}
                  </p>
                  <p className={style.name}>
                    {player.name} {player.app}
                  </p>
                </div>
              ))}
            </div>
            <div className={classNames(style.players, style.playersVisit)}>
              <p
                className={style.nameTeam}
                style={{ color: match?.visit?.colorShirt }}
              >
                {match?.visit?.name}
              </p>
              {match?.visit?.players?.map((player) => (
                <div key={player.id} className={style.dataPlayer}>
                  <p className={style.number}>
                    {player.numShirt < 10
                      ? `0${player.numShirt}`
                      : player.numShirt}
                  </p>
                  <p className={style.name}>
                    {player.name} {player.app}
                  </p>
                </div>
              ))}
            </div>
          </div>
          <div className={style.dataTeams}>
            <p className={style.titleSection}>Estadisticas generales</p>
            <ItemsData
              title="victorias"
              local={match?.local?.general_table?.jg}
              visit={match?.visit?.general_table?.jg}
              colorLocal={match?.local?.colorShirt}
              colorVisit={match?.visit?.colorShirt}
            />
            <ItemsData
              title="derrotas"
              local={match?.local?.general_table?.jp}
              visit={match?.visit?.general_table?.jp}
              colorLocal={match?.local?.colorShirt}
              colorVisit={match?.visit?.colorShirt}
            />
            <ItemsData
              title="empates"
              local={match?.local?.general_table?.je}
              visit={match?.visit?.general_table?.je}
              colorLocal={match?.local?.colorShirt}
              colorVisit={match?.visit?.colorShirt}
            />
            <ItemsData
              title="goles a favor"
              local={match?.local?.general_table?.gf}
              visit={match?.visit?.general_table?.gf}
              colorLocal={match?.local?.colorShirt}
              colorVisit={match?.visit?.colorShirt}
            />
            <ItemsData
              title="goles en contra"
              local={match?.local?.general_table?.ge}
              visit={match?.visit?.general_table?.ge}
              colorLocal={match?.local?.colorShirt}
              colorVisit={match?.visit?.colorShirt}
            />
          </div>
        </div>
      </div>
      <div
        className={
          showStories ? classNames(style.match, style.view) : style.match
        }
      >
        <div className={style.dataMatch}>
          <div className={style.team}>
            <div className={style.contName}>
              <p className={style.name}>{match?.local?.name}</p>
            </div>
            <div className={style.contShield}>
              <p className={style.shield}>
                <FontAwesomeIcon
                  icon={faShieldAlt}
                  color={match?.local?.colorShirt}
                />
              </p>
            </div>
          </div>
          <div className={style.score}>
            {/* <p className={style.day}>Liga · Jornada {match?.day}</p> */}
            <p className={style.goals}>
              {match?.goalLocal}
              <span> - </span>
              {match?.goalVisit}
            </p>
            {/* <p className={classNames(style.status, style[match?.StatusMatch])}>
              {match?.StatusMatch}
            </p> */}
          </div>
          <div className={classNames(style.team, style.teamVisit)}>
            <div className={style.contShield}>
              <p className={style.shield}>
                <FontAwesomeIcon
                  icon={faShieldAlt}
                  color={match?.visit?.colorShirt}
                />
              </p>
            </div>
            <div className={style.contName}>
              <p className={style.name}>{match?.visit?.name}</p>
            </div>
          </div>
        </div>
        <div className={style.story}>
          {storyMatch?.map((story) =>
            story.type !== 0 ? (
              <ItemStory
                key={story?.id}
                team={story?.team}
                title={story?.title}
                desc={story?.description}
                type={story?.type}
                minute={story?.minute}
              />
            ) : (
              <Status key={story?.id} status={story?.title} />
            )
          )}
          <div ref={storiesRef} />
        </div>
      </div>
    </div>
  );
}

const ItemsData = ({ title, local, visit, colorLocal, colorVisit }) => (
  <div className={style.contItem}>
    <p className={style.data}>{local}</p>
    <div className={style.progress}>
      <ProgressBar
        completed={local ? local : 0}
        maxCompleted={local + visit}
        dir="rtl"
        baseBgColor="#22262b"
        height=".6rem"
        isLabelVisible={false}
        bgColor={colorLocal}
        animateOnRender={true}
      />
    </div>
    <div className={style.contTitle}>
      <p className={style.title}>{title}</p>
    </div>
    <div className={style.progress}>
      <ProgressBar
        completed={visit ? visit : 0}
        maxCompleted={local + visit}
        baseBgColor="#22262b"
        height=".6rem"
        isLabelVisible={false}
        bgColor={colorVisit}
        animateOnRender={true}
      />
    </div>
    <p className={style.data}>{visit}</p>
  </div>
);

const Status = ({ status }) => (
  <div className={style.contStatus}>
    <div className={style.itemStatus}>
      <p className={style.textStatus}>{status}</p>
    </div>
  </div>
);

const ItemStory = ({ type, team, title, desc, minute }) => {
  const IconStory = (storyType) => {
    let icon = null;
    if (storyType === 1) {
      icon = goal;
    }
    if (storyType === 2) {
      icon = foul;
    }
    if (storyType === 3) {
      icon = yellow;
    }
    if (storyType === 4) {
      icon = red;
    }
    if (storyType === 5) {
      icon = corner;
    }
    if (storyType === 6) {
      icon = penalty;
    }
    if (storyType === 7) {
      icon = change;
    }
    return icon;
  };

  return (
    <div
      className={
        team === 1
          ? classNames(style.iteamStory, style.storyLocal)
          : classNames(style.iteamStory, style.storyVisit)
      }
    >
      <div className={classNames(style.infoStory, style.data)}>
        <p className={style.title}>{title}</p>
        <p className={style.desc}>{desc}</p>
      </div>
      <div
        className={
          type === 1
            ? classNames(style.contIcon, style.iconGoal)
            : style.contIcon
        }
      >
        <img className={style.icon} src={IconStory(type)} alt="" />
      </div>
      <div className={classNames(style.contMinute, style.data)}>
        <p className={style.minute}>{minute}'</p>
      </div>
    </div>
  );
};

export default StoryMatch;
